import { render, staticRenderFns } from "./office-list.vue?vue&type=template&id=64b3ec58&scoped=true&"
import script from "./office-list.vue?vue&type=script&lang=js&"
export * from "./office-list.vue?vue&type=script&lang=js&"
import style0 from "./office-list.vue?vue&type=style&index=0&id=64b3ec58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b3ec58",
  null
  
)

export default component.exports